module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("1540c"))).then(() => parcelRequire('aJVI6'));